import { observer } from "mobx-react-lite";
import { useSearchStore } from "../..";
import useOpenSelectedItem from "../../hooks/useOpenSelectedItem";
import SearchType from "../../interfaces/SearchType";
import styles from './RecentSearchItem.module.css';

function RecentSearchItem({ query, type, className, index }: IRecentSearchItemProps) {
    const searchStore = useSearchStore();

    const click = () => searchStore.setSearch(query, type);
    useOpenSelectedItem(index, click);

    return (
        <div className={[styles.container, className].join(" ")} onClick={click}>
            <div className={styles.type}>{type}</div>
            <div>{query}</div>
        </div>
    );
}

interface IRecentSearchItemProps {
    query: string;
    type: SearchType;
    className?: string;
    index?: number;
}

export default observer(RecentSearchItem);